// --------------------------------------------------------------
// accessories.js
// --------------------------------------------------------------

/* Creates a slideshow showcase */
createShowcase = function (showcaseId) {
    $('#'+showcaseId+'Showcase')
    .after('<div id="'+showcaseId+'Pager" class="showcasePager">')
    .cycle({
        cleartypeNoBg: true,
        fx: 'scrollHorz',
        timeout: 0,
        pager: "#"+showcaseId+"Pager",
        nowrap: 1,
        speed: 500,
        pagerAnchorBuilder: function() {
            return '<a href="#"></a>'
        }
    });

    /* Handle swiping left */
    $("#"+showcaseId+"Showcase a").on("swipeleft", function(event){
         swipeShowcase(showcaseId, 'left');
    });

    /* Handle swiping right */
    $("#"+showcaseId+"Showcase a").on("swiperight", function(){
         swipeShowcase(showcaseId, 'right');
    });
}

/* cycles showcase when swiping on a touch device */
swipeShowcase = function (showcaseId, direction) {
    if(direction == 'left'){
        $("#"+showcaseId+"Showcase").cycle('next');
    }else{
        $("#"+showcaseId+"Showcase").cycle('prev');
    }
}

$(function() {
    if($('#accessories #showcase .container').length) {
        // Setup cycle behavior for showcase section on page load
        $('#accessories #showcase .container').cycle({
            cleartypeNoBg : true,
            pager: '#showcase-pager',
            pagerAnchorBuilder: function(index) {
                // return selector string for existing anchor
                return '#showcase-pager [id$="-page"]:eq(' + index + ')';
            }
        });

        // Pause slideshow when pager is clicked
        $('#showcase-pager').click(function() {
            $('#accessories #showcase .container').cycle('pause');
        });

        createShowcase("cw-500");
        createShowcase("cs-400");
        createShowcase("cwm-250");
        createShowcase("cwm-125");
    }
});

/* exported addToCart */
/*global $:false */

window.addToCart = function(item, quantity, timeout) {
    var formData = {
        oper: "add",
        item: item,
        quant: quantity
    };
    return $.ajax({
        type: "GET",
        url: "/cart/store/adjustcart.cgi",
        data: formData,
        timeout: timeout
    }).promise();
};

// Creates the auto-click function for use on small layouts
$(function() {
    function aimAssistToggle() {
        $(".js-aim-assist-trigger").toggleClass("active");
    }
    // Tests whether or not there is the element that needs this code.
    if($(".js-aim-assist-trigger").length) {
        // Gets the width of the viewport to determine if aimAssistToggle
        // should be called.
        // NOTE: This only defined at load so if a user makes the viewport
        // smaller or larger, this will not adjust.
        var width = $(document).width();

        // Determines if the viewport is on a small layout.
        if (width < 450) {
            setInterval(aimAssistToggle, 2500);
        } else {
            // If the aim-assist container is clicked it should fire the
            // function to toggle the aim-assist
            $(".js-aim-assist-trigger").click(function() {
                aimAssistToggle();
            });
        }
    }
});

// This is the legacy code for the aim-assist. It's included till all the
// apps pages refactor is complete.
$(function aimAssist() {
    var width = $(document).width();
    function autoClick() {
        $(".green, .yellow, .zoom-out, .zoom-in").toggleClass("active");
    }
    if (width < 450) {
        autoClick();
        setInterval(autoClick, 2500);
    } else {
        $(".green, .yellow").click(function (e) {
            e.preventDefault();
            // toggle class (add or remove .active depending on whether it exists)
            $(".green, .yellow, .zoom-out, .zoom-in").toggleClass("active");
        });
    }
});

// VIDEO CYCLE SECTION //

$(function () {
    // VR VIDEO Plugin
    if($('.video-popup .video-popup-trigger').length) {
        $(".video-popup .video-popup-trigger").click(function () {
            var $this = $(this);
            var autoplayUrl = $("#video").attr("data-autoplay-url");
            var noplayUrl = $("#video").attr("data-noplay-url");
            var textDisplay = $("#video").attr("data-text-display");

            if ($this.hasClass('playing-video')) {
                $(".video-popup img").fadeIn();
                $(".video-popup iframe").hide();
                $this.text(textDisplay);
                $this.removeClass('playing-video');

                $("#video")[0].src = noplayUrl;
            } else {
                $(".video-popup img").hide();
                $(".video-popup iframe").fadeIn();
                $this.text('Close Video');
                $this.addClass('playing-video');
                $("#video")[0].src = autoplayUrl;

            }
        });
    }
});

    /* lightbox */
    $(document).ready(function() {
        if($('.lightbox-video').length) {
            $('.lightbox-video').magnificPopup({type:'iframe', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade'});
        }
    });

// --------------------------------------------------------------
// hardware.js
// --------------------------------------------------------------

$(function() {


    // Setup cycle behavior for showcase section on page load
    if($('#hardware #showcase .container').length) {
        $('#hardware #showcase .container').cycle({
            cleartypeNoBg : true,
            pager: '#showcase-pager',
            pagerAnchorBuilder: function(index) {
                // return selector string for existing anchor
                return '#showcase-pager [id$="-page"]:eq(' + index + ')';
            }
        });
    }


    // Pause slideshow when pager is clicked
    if($('#showcase-pager').length) {
        $('#showcase-pager').click(function() {
            $('#hardware #showcase .container').cycle('pause');
        });
    }


    // Toggle specs
    if($('.specs-toggle').length) {
        $('.specs-toggle').click(function() {
            $(this).closest('[id^="list-item-"]').toggleClass('specs-on');
        });
    }


    // // Add hover intent to specs toggle button
    // var toggleIntentClass = function() {
    //     $(this).closest('[id^="list-item-"]').toggleClass('specs-on-hover');
    // };

    // var hoverIntentSettings = {
    //     sensitivity: 5,
    //     interval: 50,
    //     timeout: 0,
    //     over: toggleIntentClass,
    //     out: toggleIntentClass
    // };

    // $('.specs-toggle').hoverIntent(hoverIntentSettings);
});

(function ($) {

    var FLYOUT_ID = "#cart-flyout-toggle";
    var FLYOUT_TOGGLE = "cart-flyout-on";
    var CART_FLYOUT_ID = "#cart-flyout";
    var FLYOUT_OPEN_ID = "";
    var FLYOUT_CLOSE_ID = "#cart-close-trigger";
    var CART_FORM = ".cartForm";
    var AJAX_FORM = ".ajaxForm";
    var CART_ID = "cartid";
    var SESSION_ID = "sessionID";
    var LOCALSTORAGE_KEY = "opticart";
    var CART_CONTENT_DIV = "#cart-products";
    var CLEAR_CART_LINK = "#clear-cart-link";
    var CART_REMOVE_ALL = ".remove.all";
    var REMOVE_CLASS = ".remove-button";
    var CART_PAGE = "cart/";
    var CART_PAGE_REMOVE = ".remove";
    var CART_PAGE_UPDATE = ".update.quantity";
    var CHECKOUT_LINK = ".checkout-link";
    var ACCESSORY_CHECK = "/cart/optitrack/accessory_check.cgi?override=1&overrideURL=" + window.location.host;
    var TOTAL_ID = "#cart-price-total";
    var ITEM_TOTAL_ID = "#cart-item-total";
    var CART_SUMMARY_ID = "#cart-summary, .checkout-link";
    var EMPTY_CLASSNAME = "cart-empty";
    var QUANTITY_FIELD = ".quantity-field";
    var INVALIDATE_EVENT = "invalidateCart";
    var SUCCESS_PAGE = "success.html";
    var VIEW_CART_LINK = "#view-cart-link";
    var BUNDLE_FORM_CLASS = ".addCartBundle";
    var HASH_DATA_ATTR = "hash";
    var QUOTE_FORM = "#quoteForm";
    var QUOTE_FORM_COUNTRY_LABEL = "#quote-form-country-label";
    var QUOTE_FORM_COUNTRY_SELECT = "#quote-form-country-select";
    var QUOTE_FORM_STATE_LABEL = "#quote-form-state-label";
    var QUOTE_FORM_STATE_SELECT = "#quote-form-state-select";
    var QUOTE_DIALOG_CLASS = "quote-dialog-on";
    var QUOTE_LINK = ".quote-form-link";
    var CLOSE_DIALOG = ".close-quote-dialog";
    var CART_ITEM_ADDED_CLASS = "cart-item-added";
    var CART_IGNORE = "cartIgnore";

    var ADDING_CLASSNAME = "is_adding";
    var ADDED_CLASSNAME = "added";
    var CART_ERROR_CLASSNAME = "cart_error";

    // HTML TEMPLATES

    var REMOVE_BUTTON_HTML = "<div class=\"remove-button\" data-itemid=\"{item_id}\"><svg class=\"remove-symbol\" xmlns=\"http://www.w3.org/2000/svg\" width=\"27\" height=\"27\" viewBox=\"0 0 27 27\"><path fill=\"currentColor\" d=\"M14,13 L20,13 L20,14 L14,14 L14,20 L13,20 L13,14 L7,14 L7,13 L13,13 L13,7 L14,7 L14,13 Z\" transform=\"rotate(45 13.5 13.5)\"/></svg></div>";
    var TOTALS_DIV_HTML = "<div class=\"product-quantity-price-group\"><input data-itemid=\"{item_id}\" class=\"quantity-field\" pattern = \"[1-9][0-9]{0,4}\" name=\"quantity\" type=\"number\" min=\"1\"  max=\"9999\" value=\"{item_quantity}\"><span class=\"product-unit-price\">{item_price}</span><span class=\"product-total-price\">{item_total}</span></div>";
    var EMPTY_CART_HTML = "Your cart is empty";

    $.fn.optiCart = function (element, options) {
        // This is the easiest way to have default options.
        var settings = $.extend({
            // These are the defaults.
            storename: "optitrack",
            baseurl: window.location.origin + "/newadminapi/cart/"
        }, options);

        if (window.location.origin.indexOf("localdev") >= 0) {
            settings.baseurl = "http://localhost:9000/cart/";
            //settings.baseurl = "https://dev4.optitrack.private/newadminapi/cart/";
        }

        var currentCart = {};

        // Auto-update when quantity field is changed on Cart page
        $(QUANTITY_FIELD).change(function () {
            var newQuantity = parseInt($(event.currentTarget).val());
            var old = parseInt($(this).data("old"));
            if (newQuantity > 0) {
                $(this).siblings('[type="submit"]').click();
            } else {
                $(this).val(old);
            }
        });

        // Add class to show quote dialog on cart page
        $(QUOTE_LINK).on('click', function () {
            $('html').addClass(QUOTE_DIALOG_CLASS);
        })

        // Remove class to hide quote dialog on cart page
        $(CLOSE_DIALOG).on('click', function () {
            $('html').removeClass(QUOTE_DIALOG_CLASS);
        });


        // hide state select if country isn't USA or Canada
        $(QUOTE_FORM_COUNTRY_SELECT).on('change', function () {
            var countryValue = $(QUOTE_FORM_COUNTRY_SELECT).val();
            if(countryValue ==='United States') {
                $(QUOTE_FORM_STATE_LABEL).show();
                $(QUOTE_FORM_STATE_SELECT).show();
                $(QUOTE_FORM_STATE_SELECT).prop('required', true);
                $("#quote-form-province-select").prop('required', false);
                $("#quote-form-province-label").hide();
                $("#quote-form-province-select").hide();
            }else if(countryValue ==='Canada') {
                $("#quote-form-state-label").hide();
                $("#quote-form-state-select").hide();
                $("#quote-form-province-label").show();
                $("#quote-form-province-select").show();
                $(QUOTE_FORM_STATE_SELECT).prop('required', false);
                $("#quote-form-province-select").prop('required', true);
            }else {
                $(QUOTE_FORM_STATE_LABEL).hide();
                $(QUOTE_FORM_STATE_SELECT).hide();
                $(QUOTE_FORM_STATE_SELECT).val('');
                $("#quote-form-province-label").hide();
                $("#quote-form-province-select").hide();
                $(QUOTE_FORM_STATE_SELECT).prop('required', false);
                $("#quote-form-province-select").prop('required', false);
            }
        })

        // Submit quote request
        $(QUOTE_FORM).submit(function (e) {
            e.target.disabled = true;
            $("html").addClass('quote-request-sent');
            e.preventDefault();
            e.returnValue = false;

            var quoteRequest = {
                cartId: currentCart.id,
                firstName: $(this).find("[name='firstName']").val(),
                lastName: $(this).find("[name='lastName']").val(),
                company: $(this).find("[name='company']").val(),
                email: $(this).find("[name='email']").val(),
                country: $(this).find("[name='country']").val(),
                state: $(this).find("[name='state']").val(),
                application: $(this).find("[name='application']").val()
            };

            /* Use province if Canada */
            if(quoteRequest.country ==='Canada') {
                quoteRequest.state = $(this).find("[name='province']").val();
            }

            /* Use empty string for all null values */
            for (var prop in quoteRequest) {
                if(quoteRequest.hasOwnProperty(prop)) {
                    if(quoteRequest[prop] == null) {
                        quoteRequest[prop]="";
                    }
                }else{
                    quoteRequest[prop]="";
                }
            }

            $.ajax({
                type: "POST",
                url: settings.baseurl + settings.storename + "/quote",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(quoteRequest)
            }).promise().always(function () {
                $("html").addClass('quote-request-returned');
                $("html").removeClass('quote-request-sent');
                $('#quote-submitted-message').find('.close-quote-dialog').focus()
            });
            return false;
        });

        $(FLYOUT_ID).on("click", function () {
            if (window.location.href.indexOf(CART_PAGE) <= 0) {
                $("html").toggleClass(FLYOUT_TOGGLE);
            }
        });
        $(FLYOUT_CLOSE_ID).on("click", function (e) {
            if (window.location.href.indexOf(CART_PAGE) <= 0) {
                e.preventDefault();
                $("html").removeClass(FLYOUT_TOGGLE);
            }
        });
        $(FLYOUT_OPEN_ID).on("click", function (e) {
            if (window.location.href.indexOf(CART_PAGE) <= 0) {
                e.preventDefault();
                $("html").addClass(FLYOUT_TOGGLE);
            }
        });

        $(CLEAR_CART_LINK).on("click", function () {
            clear();
        });

        $(CART_REMOVE_ALL).submit(function (e) {
            e.preventDefault();
            e.returnValue = false;
            clear();
            return false;
        });

        $(CART_PAGE_UPDATE).submit(function (e) {
            e.preventDefault();
            e.returnValue = false;
            var form = $(this);
            var newQuantity = $("[name='quant']", form).val();
            var item_id = $("[name='itemref']", form).val();
            updateQuantity(item_id, newQuantity);
            return false;
        });

        $(CART_PAGE_REMOVE).submit(function (e) {
            e.preventDefault();
            e.returnValue = false;
            var form = $(this);
            var item_id = $("[name='itemref']", form).val();
            removeItem(item_id);
            return false;
        });

        $(CHECKOUT_LINK).on("click", function () {
            window.location = ACCESSORY_CHECK;
        });

        // look for any add to cart forms and hijack them
        $(CART_FORM).submit(function (e) {
            return oldFormClick(e, $(this));
        });

        $(document).ajaxComplete(function (event, xhr, options) {
            if (options.support_form === true) {
                $(CART_FORM).submit(function (e) {
                    return oldFormClick(e, $(this));
                });
            }
        });

        $(".v120slim.buy .choice .action a").unbind("click");

        $(BUNDLE_FORM_CLASS).on("click", function (e) {
            if (!e.target.classList.contains(CART_IGNORE)) {
                e.stopImmediatePropagation();
                e.preventDefault();
                addBundle($(this));
                return false;
            }
            return true;
        });

        // =========================================================================== //

        var oldFormClick = function (e, form) {
            e.preventDefault();
            e.returnValue = false;
            addItemForm(form);
            return false;
        };

        var initCart = function () {

            if (window.location.pathname.indexOf(SUCCESS_PAGE) >= 0) {
                clearCart();
                return;
            }

            currentCart = load();
            var cartId = $.cookie(CART_ID);
            if ((!currentCart && !cartId) || (currentCart && currentCart.status !== "shopping")) {
                $.ajax({
                    type: "GET",
                    url: settings.baseurl + settings.storename + "/new",
                    withCredentials: true
                }).promise().done(function (cart) {
                    save(cart);
                }).always(function () {
                    renderCart();
                });
            } else if (!currentCart || !currentCart.hasOwnProperty("id")) {
                currentCart = {
                    id: cartId
                };
                $.ajax({
                    type: "GET",
                    url: buildUrl()
                }).promise().done(function (cart) {
                    save(cart);
                }).always(function () {
                    renderCart();
                });
            } else {
                save(currentCart);
                renderCart();
            }
        };

        var clearClasses = function (element) {
            $('html').removeClass(CART_ITEM_ADDED_CLASS);
            $(element).removeClass(ADDING_CLASSNAME);
            $(element).removeClass(ADDED_CLASSNAME);
            $(element).removeClass(CART_ERROR_CLASSNAME);
        };

        var save = function (cart) {
            currentCart = cart;
            $.cookie(CART_ID, currentCart.id, { path: "/" });
            $.cookie(SESSION_ID, currentCart.session_id, { path: "/" });
            store.set(LOCALSTORAGE_KEY, currentCart);
        };

        var invalidateCart = function () {
            currentCart = {};
            store.set(LOCALSTORAGE_KEY, currentCart);
            renderCart();
        };

        var clearCart = function () {
            currentCart = {};
            $.removeCookie(CART_ID);
            $.removeCookie(SESSION_ID);
            store.set(LOCALSTORAGE_KEY, currentCart);
            renderCart();
        };

        var load = function () {
            return store.get(LOCALSTORAGE_KEY);
        };

        var count = function () {
            return currentCart.total_item_count;
        };

        var total = function () {
            if (currentCart) {
                return currentCart.total_price;
            }
            return 0.0;
        };

        var renderCartItem = function (item) {
            var pnumbers = $.map(item.options, function (val) {
                // Do something
                return val.item_part_number;
            });

            var partNumber = item.part_number;
            if (pnumbers && pnumbers.length > 0) {
                partNumber = partNumber + "." + pnumbers.join(".");
            }
            var div = $(CART_CONTENT_DIV);
            var productDiv = "<div class=\"product\">";
            if (item.thumbnail) {
                if (item.url) {
                    productDiv += "<a class=\"product-image\" href=\"" + item.url + "\">";
                    productDiv += "<img class=\"product-image\" src=\"" + item.thumbnail + "\" alt=\"" + item.name + "\"></a>";
                    productDiv += "<a class=\"product-name\" href=\"" + item.url + "\">" + item.name + "</a>";
                }
                else {
                    productDiv += "<img class=\"product-image\" src=\"" + item.thumbnail + "\" alt=\"" + item.name + "\">";
                    productDiv += "<span class=\"product-name\">" + item.name + "</span>";
                }
            }
            productDiv += "<div class=\"part-number\">Part Number: " + partNumber + "</div>";
            if (item.options) {
                productDiv += "<div class=\"product-options\"><ul>";
                $.each(item.options, function (i, option) {
                    productDiv += "<li>" + option.item_name + "</li>";
                });
                productDiv += "</ul></div>";
            }
            productDiv += TOTALS_DIV_HTML.replace("{item_quantity}", item.quantity).replace("{item_price}", currency(item.unit_price_with_options)).replace("{item_total}", currency(item.total_price)).replace("{item_id}", item.id);
            productDiv += REMOVE_BUTTON_HTML.replace("{item_id}", item.id);
            productDiv += "</div>";
            div.append(productDiv);
        };

        var renderTotals = function () {
            $(TOTAL_ID).text(currency(total()));
            if (count() === 1) {
                $(ITEM_TOTAL_ID).text(count() + " item");
            }
            else {
                $(ITEM_TOTAL_ID).text(count() + " items");
            }
            $(CART_SUMMARY_ID).show();
        };

        var renderCart = function () {
            $("html").addClass(EMPTY_CLASSNAME);
            $(CART_CONTENT_DIV).empty();
            if (currentCart) {
                if (currentCart.items && currentCart.items.length > 0) {
                    $("html").removeClass(EMPTY_CLASSNAME);
                    $.each(currentCart.items, function (idx, item) {
                        renderCartItem(item);
                    });
                    renderTotals();
                }
                registerCartEvents();
            }
        };

        var registerCartEvents = function () {
            $(REMOVE_CLASS).on("click", function (event) {
                var item_id = $(event.currentTarget).data("itemid");
                if (item_id) {
                    removeItem(item_id);
                }
            });

            $(QUANTITY_FIELD).keydown(function () {
                // Save old value.
                if (!$(this).val() || (parseInt($(this).val()) > 0)) { }
                $(this).data("old", $(this).val());
            });

            $(QUANTITY_FIELD).change(function (event) {
                var item_id = $(event.currentTarget).data("itemid");
                var newQuantity = parseInt($(event.currentTarget).val());
                var old = parseInt($(this).data("old"));
                if (item_id && newQuantity > 0) {
                    updateQuantity(item_id, newQuantity);
                } else if (item_id && newQuantity <= 0) {
                    var r = confirm("This item will be removed from your cart.  Proceed?");
                    if (r === true) {
                        removeItem(item_id);
                    } else {
                        $(this).val(old);
                    }
                } else if (item_id) {
                    $(this).val(old);
                }
            });


        };

        var reload = function () {
            if (window.location.href.indexOf(CART_PAGE) > -1) {
                window.location.reload();
            }
        };

        var buildCartItem = function (form) {
            var cartItem = {
                cart_id: currentCart.id,
                product_id: form.find("[name='item']").val(),
                quantity: form.find("[name='quant']").val(),
                options: []
            };

            var options = form.find(".options li.option");
            options.each(function (idx, li) {
                var groupId = $(li).find("ul").data("group_id");
                var inputname = $(li).find("ul").data("group");
                if (groupId) {
                    var selectedOption = $("input[name=" + inputname + "]:checked");
                    cartItem.options.push({
                        product_id: cartItem.product_id,
                        group_id: groupId,
                        item_id: selectedOption.val()
                    });
                }
            });
            return cartItem;
        };

        var buildUrl = function (endpoint) {
            var url = settings.baseurl + settings.storename + "/" + currentCart.id;
            if (endpoint) {
                url = url + "/" + endpoint;
            }
            return url;
        };

        var onCartEvent = function (cart) {
            save(cart);
            renderCart();
            reload();
        };

        var clear = function () {
            $.ajax({
                type: "DELETE",
                url: buildUrl("remove")
            }).promise().done(function (cart) {
                onCartEvent(cart);
            });
        };

        var removeItem = function (itemId) {
            $.ajax({
                type: "DELETE",
                url: buildUrl("item/" + itemId)
            }).promise().done(function (cart) {
                onCartEvent(cart);
            });
        };

        var updateQuantity = function (itemId, newQuantity) {
            $.ajax({
                type: "POST",
                url: buildUrl(itemId + "/" + newQuantity)
            }).promise().done(function (cart) {
                onCartEvent(cart);
            });
        };

        var currency = function (input) {
            if (input) {
                return numeral(input).format("$0,0.00");
            }
            return input;
        };

        var addItemForm = function (form) {
            clearClasses(form);
            $(form).addClass(ADDING_CLASSNAME);
            var cartItem = buildCartItem(form);
            return $.ajax({
                type: "POST",
                data: JSON.stringify(cartItem),
                contentType: "application/json; charset=utf-8",
                url: buildUrl("item")
            }).promise().done(function (cart) {
                onCartEvent(cart);
                $('html').addClass(CART_ITEM_ADDED_CLASS);
                $(form).addClass(ADDED_CLASSNAME);
            }).fail(function () {
                $(form).addClass(CART_ERROR_CLASSNAME);
            }).always(function () {
                $(form).removeClass(ADDING_CLASSNAME);
            });
        };

        var addBundle = function (element) {
            // {id}/bundle/{hash}
            var hash = $(element).data(HASH_DATA_ATTR);
            var quantity = "1";
            var temp = $(element).closest('.choice').find('.quantity').val();
            if (temp) {
                quantity = temp;
            }
            if (hash) {
                clearClasses(element);
                $(element).addClass(ADDING_CLASSNAME);
                return $.ajax({
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    url: buildUrl("bundle/" + hash + "/" + quantity)
                }).promise().done(function (cart) {
                    onCartEvent(cart);
                    $('html').addClass(CART_ITEM_ADDED_CLASS);
                    $(element).addClass(ADDED_CLASSNAME);
                }).fail(function () {
                    $(element).addClass(CART_ERROR_CLASSNAME);
                }).always(function () {
                    $(element).removeClass(ADDING_CLASSNAME);
                });
            }
        };

        initCart();
    };

})(jQuery);

$(function ($) {
    $("#cart-flyout").optiCart()

    // Allow clicking on the Cart flyout heading to close the flyout.
    $("#cart-flyout-header .heading").on("click", function () {
        $("#cart-flyout-toggle").click()
    })
});


$(function() {


    // Check to see if the Main Menu toggle is checked and apply appropriate class
    var mainMenuToggled = function() {
        var isChecked = $( '#main-menu-toggle:checked' ).length;

        if ( isChecked > 0) {
            $('html').addClass('main-menu-on')
        }
        else {
            $('html').removeClass('main-menu-on')
            $('#main-menu').scrollTop(0) // Scroll main menu to top so logotype is not out of view when closed in short viewports
        }
    }
    mainMenuToggled()

    $('#main-menu-toggle').on('change', function () {
        mainMenuToggled()
    });

    $('#mobile-close').on('click', function (e) {
        e.preventDefault();
        document.getElementById("main-menu-toggle").checked = false;
        mainMenuToggled();
    });

});


/* Sub Menu */
/*** SubNav CTA ***/
function subCtaHandler(entries) {
    if('IntersectionObserver' in window) {
      for(var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        var subNav = window.document.getElementById('subNav');

        if (entry.isIntersecting) {
          /* Normal SubNav */
          if(!subNav.classList.contains('subNavStandard') && subNav.classList.contains('subNavCta')) {
            subNav.classList.add("subNavStandard");
          }
          if(subNav.classList.contains('subNavCta')) {
            subNav.classList.remove("subNavCta");
          }

        } else {

          /* CTA SubNav */

          if(!subNav.classList.contains('subNavCta')) {
            subNav.classList.add("subNavCta");
          }
          if(subNav.classList.contains('subNavStandard')) {
            subNav.classList.remove("subNavStandard");
          }

          /* Resets the subnav horizontal scrolling */
          subNavCTAReset();
          subNavCTAReset

        }
      }
    }
  }
  /* Use the intersection observer if the HTML tag has the correct classname */
  if(document.querySelector("html").classList.contains("subnav-cta-on-scroll")) {
    if('IntersectionObserver' in window) {


      if(document.getElementById("subNav")) {
        var ctaTopDistance = 500;
        if(document.getElementById("subNav").dataset.ctaTopDistance) {
          ctaTopDistance = document.getElementById("subNav").dataset.ctaTopDistance;
        }
        var subCtaObserver = new IntersectionObserver(subCtaHandler, {rootMargin: ctaTopDistance+'px 0px 0px 0px'});
        subCtaObserver.observe(document.getElementById("mainNav"));
      }
    }
  }
  /*** END SubNav CTA ***/
  /* Scroll the sub menu to the right */
  var scrollMenuRight = function() {

    var menuContent = document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent");
    var linksWrapper = menuContent.querySelector(".m3SubMenu");

    var allLinks = document.getElementById('m3SubMenuWrapper').querySelectorAll(".m3SubMenuContent .m3SubMenu a");

    /* Get the translateX amount */
    var linksWrapperStyle = window.getComputedStyle(linksWrapper);
    var linksWrapperMatrix = new WebKitCSSMatrix(linksWrapperStyle.webkitTransform);
    var linksWrapperTranslateX = parseInt(linksWrapperMatrix.m41);

      /* Loop through all links in nav */
      for(var i=0; i < allLinks.length; i++) {
        var linkPosition = allLinks[i].offsetLeft;
        var linkWidth = allLinks[i].offsetWidth;

        /* Check if link is outside visible content */
        if((linkPosition + linkWidth ) > (menuContent.offsetWidth + Math.abs(linksWrapperTranslateX))) {

          /* Convert the linkPosition to a negative to move in the correct direction */
          var newX = linkPosition * -1;

          /* Check if this will scroll past the last link */
          if((linksWrapper.offsetWidth + newX) < menuContent.offsetWidth) {
            /* Only scroll to the end of the content */
            newX = (linksWrapper.offsetWidth - menuContent.offsetWidth) * -1;
          }

          /* Translate the parent */
          linksWrapper.style.transform = "translateX("+newX+"px)";

          /* Update layout after animation */
          setTimeout(subNavLayout, 500);

          return false;
        }
      }

      subNavLayout();
  }



  /* Scroll the sub menu to the left */
  var scrollMenuLeft = function() {

    var menuContent = document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent");
    var linksWrapper = menuContent.querySelector(".m3SubMenu");
    var leftArrow = menuContent.querySelector(".subMenuLeftArrow");
    var allLinks = document.getElementById('m3SubMenuWrapper').querySelectorAll(".m3SubMenuContent .m3SubMenu a");

    /* Get the translateX amount */
    var linksWrapperStyle = window.getComputedStyle(linksWrapper);
    var linksWrapperMatrix = new WebKitCSSMatrix(linksWrapperStyle.webkitTransform);
    var linksWrapperTranslateX = parseInt(linksWrapperMatrix.m41);

    /* Subtrack one screen width from the translate */
    var newX = linksWrapperTranslateX + menuContent.offsetWidth;
    if(newX > 0) {
      newX = 0;
    }

    /* Translate the parent */
      linksWrapper.style.transform = "translateX("+newX+"px)";

    /* Update layout after animation */
      setTimeout(subNavLayout, 500);

  }

  /* Scrolls the menu to the selected link */
  var scrollMenuToSelected = function() {
    var menuContent = document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent");
    var linksWrapper = menuContent.querySelector(".m3SubMenu");
    var selectedLink = document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent .m3SubMenu a.selected");

    /* if a link is selected */
    if(selectedLink !== null) {
      var selectedLinkPosition = selectedLink.offsetLeft;
      var selectedLinkWidth = selectedLink.offsetWidth;
      var leftArrow = menuContent.querySelector(".subMenuLeftArrow");

      /* Get the translateX amount */
      var linksWrapperStyle = window.getComputedStyle(linksWrapper);
      var linksWrapperMatrix = new WebKitCSSMatrix(linksWrapperStyle.webkitTransform);
      var linksWrapperTranslateX = parseInt(linksWrapperMatrix.m41);

      /* Check if link is outside visible content */
      if((selectedLinkPosition + selectedLinkWidth ) > (menuContent.offsetWidth + Math.abs(linksWrapperTranslateX))) {

          /* Convert the linkPosition to a negative to move in the correct direction */
          var newX = selectedLinkPosition * -1;

          /* Check if this will scroll past the last link */
          if((linksWrapper.offsetWidth + newX) < menuContent.offsetWidth) {
              /* Only scroll to the end of the content */
              newX = (linksWrapper.offsetWidth - menuContent.offsetWidth) * -1;
          }

          /* If this is not the first child make room for the arrow */
            if(selectedLink !== linksWrapper.firstElementChild) {
              newX = newX + 25;
            }


          /* Translate the parent */
          linksWrapper.style.transform = "translateX("+newX+"px)";

          /* Update layout after animation */
          setTimeout(subNavLayout, 500);
      }
    }
  }

  /* Determine if the right arrow should be displayed */
  var displayRightArrow = function() {

    /* Get the links wrapper width */
    var menuContent = document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent");
    var linksWrapper = menuContent.querySelector(".m3SubMenu");
    var rightArrow = menuContent.querySelector(".subMenuRightArrow");


      /* Get the translateX amount */
      var linksWrapperStyle = window.getComputedStyle(linksWrapper);
      var linksWrapperMatrix = new WebKitCSSMatrix(linksWrapperStyle.webkitTransform);
      var linksWrapperTranslateX = parseInt(linksWrapperMatrix.m41);

    /* Hide/Display Arrow */
    if(linksWrapper.offsetWidth > ((menuContent.offsetWidth + Math.abs(linksWrapperTranslateX)))+25) {
      rightArrow.style.display = "block";
      rightArrow.addEventListener("click", scrollMenuRight);
    } else {
      rightArrow.style.display = "none";
      rightArrow.removeEventListener("click", scrollMenuRight);

      /* if right arrow is not displayed make sure the content is all the way to the right */
      if(((linksWrapper.offsetWidth + linksWrapperTranslateX) < menuContent.offsetWidth)) {

        var newX = linksWrapper.offsetWidth - menuContent.offsetWidth;
        if(newX > 0) {newX = 0;}
        linksWrapper.style.transform = "translateX("+newX+"px)";
      }
    }
  }

  var displayLeftArrow = function() {

    var menuContent = document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent");
    var linksWrapper = menuContent.querySelector(".m3SubMenu");
    var leftArrow = menuContent.querySelector(".subMenuLeftArrow");

    /* Get the translateX amount */
    var linksWrapperStyle = window.getComputedStyle(linksWrapper);
    var linksWrapperMatrix = new WebKitCSSMatrix(linksWrapperStyle.webkitTransform);
    var linksWrapperTranslateX = parseInt(linksWrapperMatrix.m41);

    /* Hide/Display Arrow */
    if(linksWrapperTranslateX < -3) {
      leftArrow.style.display = "block";
      leftArrow.addEventListener("click", scrollMenuLeft);
    } else {
      leftArrow.style.display = "none";
      leftArrow.removeEventListener("click", scrollMenuLeft);
    }
  }

  /* Updates the layout - Determines if arrows should be displayed */
  var subNavLayout = function() {
    displayRightArrow();
    displayLeftArrow();
  }


  /* Resets the subnav horizontal scroll so CTA layout is displayed corrrectly */
  var subNavCTAReset = function() {
    var linksWrapper = document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent .m3SubMenu");
    linksWrapper.style.transform = "translateX(0px)";
  }

  /*** Intersection Observer ***/
/* Gets all items on the page with the 'scrollAnimate' class */
/* if intersectionObserver is supported */
if('IntersectionObserver' in window) {
  const elements = document.querySelectorAll('.scrollAnimate');
  observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {

      /* if element is in view add class */
      if (entry.intersectionRatio > 0) {
        entry.target.classList.add('animate');

      /* check for elements that are completly in view and have the animate class */
      } else if (entry.intersectionRatio > 1 && entry.target.classList.contains('animate')) {

        /* Stops observing */
        observer.unobserve(entry.target);

      } else {
        /* if this class is removed the animation will run more than once (if elements exists viewport then reenters) */
        //entry.target.classList.remove('animate');
      }

    });
  });

  /* creates observer for each element */
  elements.forEach(function(element) {
    observer.observe(element);
  });
  }
  /*** END Intersection Observer ***/

/* Smooth scroll to anchor */
$(document).ready(function(){
  // Add smooth scrolling to all links
  $("a.localScroll").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      if($(hash).offset() != undefined) {
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 800, function(){

          // Add hash (#) to URL when done scrolling (default click behavior)
          //window.location.hash = hash;
        });
      } // end if
    } // End if
  });
});
  /* Recalculate on window resize */
  $(window).on( 'resize', function() {
    if (document.getElementById('m3SubMenuWrapper')) {
      /* Make sure the arrows are present before trying to use them */
      if(document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent .subMenuLeftArrow") && document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent .subMenuRightArrow")) {
        subNavLayout();
        scrollMenuToSelected();
      }
    }
  });

  /* Initialize the subnav */
  $(document).ready(function() {
    /* Make sure the subMenu is on the page */
    if (document.getElementById('m3SubMenuWrapper')) {

      /* Make sure the arrows are present before trying to use them */
      if(document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent .subMenuLeftArrow") && document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent .subMenuRightArrow")) {
        subNavLayout();
        scrollMenuToSelected();
      }
    }
  });
  /* END Sub Menu */

  /* Touch support */
(function(l){
  var M=Math,ce,cx,cy,dx,dy,b,f,i,m,s,t=function(e,i){m=i; i=e.touches; return{x:i[0].pageX,y:i[0].pageY,z:i.length}};
  for(i in s={touchcancel:function(e){m=0},touchstart:function(e){b=t(e,0)},touchmove:function(e){f=t(e,1)},touchend:function(e){if(b.z>1)return; ce=l.createEvent('CustomEvent');
  ce.initCustomEvent(m?(M.max(dx=M.abs(cx=f.x-b.x),dy=M.abs(cy=f.y-b.y))>25?dx>dy?cx<0?'l':'r':cy<0?'u':'d':'fc'):'fc',true,true,b); e.target.dispatchEvent(ce);}
  }) l.addEventListener(i,s[i],false)})(document);

  	/* Touch for subNav */
	if(document.getElementById('subNav')) {

    var linksWrapper = document.getElementById('m3SubMenuWrapper').querySelector(".m3SubMenuContent .m3SubMenu");

		linksWrapper.addEventListener('r', scrollMenuLeft, false);
		linksWrapper.addEventListener('l', scrollMenuRight, false);
	}




/* global google, $ */
/* exported googleTranslateElementInit, changeImage */

$.mobile.autoInitializePage = false;

$(document).ready(function(){
    setContinueShoppingLink();
});

// RANGE FINDER
$(function () {
    $(".js-range-finder--button").click(function (e) {
        e.preventDefault();

        // Gets the distance of the selected button.
        var distance = $(this).data("distance");

        // Removes the active class from the previously active button.
        $(".js-range-finder--button.active").removeClass("active");
        // Adds the active class to the seleted button.
        $(this).addClass("active");

        // Removes the active class from the previously active image
        // so that it can be added to the new image.
        $(".js-range-finder--image.active").removeClass("active");
        // Finds the image with the correct data-distance value
        // and makes it visible to match the selected button
        $(".js-range-finder--image-group").find("[data-distance='" + distance + "']").addClass("active");
    });
});

// RANGE FINDER (For Legacy Support. This should be removed after full
// refactor of apps pages is complete)
$(function () {
    $(".range-finder .btn-group .range-button").click(function (e) {
        e.preventDefault();

        // handle the button
        $(".range-finder .btn-group a.active").removeClass("active");
        $(this).addClass("active");

        // handle the image
        $(".range-finder .range-image.active").hide();
        $(".range-finder .range-image.active").removeClass("active");

        if ($(this).hasClass("range-button-50")) {
            $(".range-finder .range-50").addClass("active").show();
        }
        if ($(this).hasClass("range-button-75")) {
            $(".range-finder .range-75").addClass("active").show();
        }
        if ($(this).hasClass("range-button-100")) {
            $(".range-finder .range-100").addClass("active").show();
        }
        return false;
    });
});

// -------------------------------------------
//
// This script controls the behavior of the sub menu nagivation.
//
// -------------------------------------------


$(function() {

    var optionsWrapper = $('[id="sub-menu-options-wrapper"]');
    var scrollView = $('[id$="-sub-menu"] .container').width();


    // Calculate how far to move sub menu to the left
    var moveMenuLeft = function() {

        // Check the position of each sub menu option
        $( '[id^="sub-menu-option-"]' ).each(function( index ) {
            var menuOptionPosition = $( this ).position();

            // If it's position is greater than the container width, then scroll to it.
            if ( ( menuOptionPosition.left ) > -Math.abs( scrollView ) ) {
                optionsWrapper.scrollTo( this, 300 );
                return false;
            }
        });
    };


    // Calculate how far to move sub menu to the right
    var moveMenuRight = function() {

        // Check the position of each sub menu option
        $( '[id^="sub-menu-option-"]' ).each(function( index ) {
            var menuOptionPosition = $( this ).position();
            var menuOptionWidth = $( this ).outerWidth();

            // If it's position is greater than the container width, then scroll to it.
            if ( ( menuOptionPosition.left + menuOptionWidth ) > scrollView ) {
                optionsWrapper.scrollTo( this, 300 );
                return false;
            }
        });
    };


    // Determine if we need to show/hide the right paddle
    var showRightPaddle = function() {

        var maxScrollDistance = 0;
        var menuOptionPadding = parseFloat( $( '[id^="sub-menu-option-"]' ).last().css( 'padding-right' ) );
        var paddleRight = $( '#sub-menu-paddle-right' );

        // Calculate width of sub menu
        $('[id^="sub-menu-option-"]').each(function () {
            maxScrollDistance = maxScrollDistance + $( this ).outerWidth();
        });

        // Subtract the parent width to calculate the max scroll distance
        maxScrollDistance = maxScrollDistance - optionsWrapper.width();

        // Show/hide paddle based on scroll position
        if ( optionsWrapper.scrollLeft() >= maxScrollDistance - menuOptionPadding ) {
            paddleRight.hide();
        } else {
            paddleRight.show();
        }
    };
    showRightPaddle();


    // Determine if we need to show/hide the left paddle
    var showLeftPaddle = function() {

        var menuOptionPadding = parseFloat( $( '[id^="sub-menu-option-"]' ).first().css( 'padding-left' ) );
        var paddleLeft = $( '#sub-menu-paddle-left' );

        if ( optionsWrapper.scrollLeft() <= 0 + menuOptionPadding ) {
            paddleLeft.hide();
        } else {
            paddleLeft.show();
        }
    };
    showLeftPaddle();


    // Move sub menu when right paddle is clicked
    $( '#sub-menu-paddle-right' ).on( 'click', function () {
        moveMenuRight();
    });


    // Move sub menu when left paddle is clicked
    $('#sub-menu-paddle-left').on('click', function () {
        moveMenuLeft();
    });


    // Show/hide navigation paddles when sub menu is scrolled
    optionsWrapper.on( 'scroll', function() {
        showLeftPaddle();
        showRightPaddle();
    });


    // Show/hide navigation paddles after viewport is resized
    $(window).on( 'resize', function() {
        showLeftPaddle();
        showRightPaddle();
    });

    // Scroll to underlined option on load
    $(window).on( 'load', function() {
        $( '[id^="sub-menu-option-"]' ).each(function( index ) {
            var isUnderlined = parseInt( $( this ).find('.sub-menu-link').css('border-bottom-width') );

            if (isUnderlined) {
                $('#sub-menu-options-wrapper').scrollTo( this, 0);
            }
        });
    });
});
// Setup cycle behavior for active/passive markers section on VR page
if($('#active-passive-markers-images').length) {
    $('#active-passive-markers-images').cycle({
        cleartypeNoBg : true,
        next: '[id*="markers-caption"]'
    });
}

/*!
 * hoverIntent v1.8.1 // 2014.08.11 // jQuery v1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007, 2014 Brian Cherne
 */

/* hoverIntent is similar to jQuery's built-in "hover" method except that
 * instead of firing the handlerIn function immediately, hoverIntent checks
 * to see if the user's mouse has slowed down (beneath the sensitivity
 * threshold) before firing the event. The handlerOut function is only
 * called after a matching handlerIn.
 *
 * // basic usage ... just like .hover()
 * .hoverIntent( handlerIn, handlerOut )
 * .hoverIntent( handlerInOut )
 *
 * // basic usage ... with event delegation!
 * .hoverIntent( handlerIn, handlerOut, selector )
 * .hoverIntent( handlerInOut, selector )
 *
 * // using a basic configuration object
 * .hoverIntent( config )
 *
 * @param  handlerIn   function OR configuration object
 * @param  handlerOut  function OR selector for delegation OR undefined
 * @param  selector    selector OR undefined
 * @author Brian Cherne <brian(at)cherne(dot)net>
 */

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (jQuery && !jQuery.fn.hoverIntent) {
        factory(jQuery);
    }
})(function($) {
    'use strict';

    // default configuration values
    var _cfg = {
        interval: 100,
        sensitivity: 6,
        timeout: 0
    };

    // counter used to generate an ID for each instance
    var INSTANCE_COUNT = 0;

    // current X and Y position of mouse, updated during mousemove tracking (shared across instances)
    var cX, cY;

    // saves the current pointer position coordinated based on the given mouse event
    var track = function(ev) {
        cX = ev.pageX;
        cY = ev.pageY;
    };

    // compares current and previous mouse positions
    var compare = function(ev,$el,s,cfg) {
        // compare mouse positions to see if pointer has slowed enough to trigger `over` function
        if ( Math.sqrt( (s.pX-cX)*(s.pX-cX) + (s.pY-cY)*(s.pY-cY) ) < cfg.sensitivity ) {
            $el.off('mousemove.hoverIntent'+s.namespace,track);
            delete s.timeoutId;
            // set hoverIntent state as active for this element (so `out` handler can eventually be called)
            s.isActive = true;
            // clear coordinate data
            delete s.pX; delete s.pY;
            return cfg.over.apply($el[0],[ev]);
        } else {
            // set previous coordinates for next comparison
            s.pX = cX; s.pY = cY;
            // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
            s.timeoutId = setTimeout( function(){compare(ev, $el, s, cfg);} , cfg.interval );
        }
    };

    // triggers given `out` function at configured `timeout` after a mouseleave and clears state
    var delay = function(ev,$el,s,out) {
        delete $el.data('hoverIntent')[s.id];
        return out.apply($el[0],[ev]);
    };

    $.fn.hoverIntent = function(handlerIn,handlerOut,selector) {
        // instance ID, used as a key to store and retrieve state information on an element
        var instanceId = INSTANCE_COUNT++;

        // extend the default configuration and parse parameters
        var cfg = $.extend({}, _cfg);
        if ( $.isPlainObject(handlerIn) ) {
            cfg = $.extend(cfg, handlerIn );
        } else if ($.isFunction(handlerOut)) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector } );
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut } );
        }

        // A private function for handling mouse 'hovering'
        var handleHover = function(e) {
            // cloned event to pass to handlers (copy required for event object to be passed in IE)
            var ev = $.extend({},e);

            // the current target of the mouse event, wrapped in a jQuery object
            var $el = $(this);

            // read hoverIntent data from element (or initialize if not present)
            var hoverIntentData = $el.data('hoverIntent');
            if (!hoverIntentData) { $el.data('hoverIntent', (hoverIntentData = {})); }

            // read per-instance state from element (or initialize if not present)
            var state = hoverIntentData[instanceId];
            if (!state) { hoverIntentData[instanceId] = state = { id: instanceId }; }

            // state properties:
            // id = instance ID, used to clean up data
            // timeoutId = timeout ID, reused for tracking mouse position and delaying "out" handler
            // isActive = plugin state, true after `over` is called just until `out` is called
            // pX, pY = previously-measured pointer coordinates, updated at each polling interval
            // namespace = string used as namespace for per-instance event management

            // clear any existing timeout
            if (state.timeoutId) { state.timeoutId = clearTimeout(state.timeoutId); }

            // event namespace, used to register and unregister mousemove tracking
            var namespace = state.namespace = '.hoverIntent'+instanceId;

            // handle the event, based on its type
            if (e.type === 'mouseenter') {
                // do nothing if already active
                if (state.isActive) { return; }
                // set "previous" X and Y position based on initial entry point
                state.pX = ev.pageX; state.pY = ev.pageY;
                // update "current" X and Y position based on mousemove
                $el.on('mousemove.hoverIntent'+namespace,track);
                // start polling interval (self-calling timeout) to compare mouse coordinates over time
                state.timeoutId = setTimeout( function(){compare(ev,$el,state,cfg);} , cfg.interval );
            } else { // "mouseleave"
                // do nothing if not already active
                if (!state.isActive) { return; }
                // unbind expensive mousemove event
                $el.off('mousemove.hoverIntent'+namespace,track);
                // if hoverIntent state is true, then call the mouseOut function after the specified delay
                state.timeoutId = setTimeout( function(){delay(ev,$el,state,cfg.out);} , cfg.timeout );
            }
        };

        // listen for mouseenter and mouseleave
        return this.on({'mouseenter.hoverIntent':handleHover,'mouseleave.hoverIntent':handleHover}, cfg.selector);
    };
});

/*! sly 1.6.1 - 8th Aug 2015 | https://github.com/darsain/sly */
!function(a,b,c){"use strict";function d(b,p,q){function K(c){var d=0,e=Gb.length;if(yb.old=a.extend({},yb),wb=tb?0:ub[rb.horizontal?"width":"height"](),Bb=zb[rb.horizontal?"width":"height"](),xb=tb?b:vb[rb.horizontal?"outerWidth":"outerHeight"](),Gb.length=0,yb.start=0,yb.end=H(xb-wb,0),Rb){d=Ib.length,Hb=vb.children(rb.itemSelector),Ib.length=0;var f,g=j(vb,rb.horizontal?"paddingLeft":"paddingTop"),h=j(vb,rb.horizontal?"paddingRight":"paddingBottom"),i="border-box"===a(Hb).css("boxSizing"),l="none"!==Hb.css("float"),m=0,n=Hb.length-1;xb=0,Hb.each(function(b,c){var d=a(c),e=c.getBoundingClientRect(),i=G(rb.horizontal?e.width||e.right-e.left:e.height||e.bottom-e.top),k=j(d,rb.horizontal?"marginLeft":"marginTop"),o=j(d,rb.horizontal?"marginRight":"marginBottom"),p=i+k+o,q=!k||!o,r={};r.el=c,r.size=q?i:p,r.half=r.size/2,r.start=xb+(q?k:0),r.center=r.start-G(wb/2-r.size/2),r.end=r.start-wb+r.size,b||(xb+=g),xb+=p,rb.horizontal||l||o&&k&&b>0&&(xb-=I(k,o)),b===n&&(r.end+=h,xb+=h,m=q?o:0),Ib.push(r),f=r}),vb[0].style[rb.horizontal?"width":"height"]=(i?xb:xb-g-h)+"px",xb-=m,Ib.length?(yb.start=Ib[0][Pb?"center":"start"],yb.end=Pb?f.center:xb>wb?f.end:yb.start):yb.start=yb.end=0}if(yb.center=G(yb.end/2+yb.start/2),V(),Ab.length&&Bb>0&&(rb.dynamicHandle?(Cb=yb.start===yb.end?Bb:G(Bb*wb/xb),Cb=k(Cb,rb.minHandleSize,Bb),Ab[0].style[rb.horizontal?"width":"height"]=Cb+"px"):Cb=Ab[rb.horizontal?"outerWidth":"outerHeight"](),Db.end=Bb-Cb,ec||N()),!tb&&wb>0){var o=yb.start,p="";if(Rb)a.each(Ib,function(a,b){Pb?Gb.push(b.center):b.start+b.size>o&&o<=yb.end&&(o=b.start,Gb.push(o),o+=wb,o>yb.end&&o<yb.end+wb&&Gb.push(yb.end))});else for(;o-wb<yb.end;)Gb.push(o),o+=wb;if(Eb[0]&&e!==Gb.length){for(var q=0;q<Gb.length;q++)p+=rb.pageBuilder.call(sb,q);Fb=Eb.html(p).children(),Fb.eq(Jb.activePage).addClass(rb.activeClass)}}if(Jb.slideeSize=xb,Jb.frameSize=wb,Jb.sbSize=Bb,Jb.handleSize=Cb,Rb){c&&null!=rb.startAt&&(T(rb.startAt),sb[Qb?"toCenter":"toStart"](rb.startAt));var r=Ib[Jb.activeItem];L(Qb&&r?r.center:k(yb.dest,yb.start,yb.end))}else c?null!=rb.startAt&&L(rb.startAt,1):L(k(yb.dest,yb.start,yb.end));ob("load")}function L(a,b,c){if(Rb&&cc.released&&!c){var d=U(a),e=a>yb.start&&a<yb.end;Qb?(e&&(a=Ib[d.centerItem].center),Pb&&rb.activateMiddle&&T(d.centerItem)):e&&(a=Ib[d.firstItem].start)}cc.init&&cc.slidee&&rb.elasticBounds?a>yb.end?a=yb.end+(a-yb.end)/6:a<yb.start&&(a=yb.start+(a-yb.start)/6):a=k(a,yb.start,yb.end),ac.start=+new Date,ac.time=0,ac.from=yb.cur,ac.to=a,ac.delta=a-yb.cur,ac.tweesing=cc.tweese||cc.init&&!cc.slidee,ac.immediate=!ac.tweesing&&(b||cc.init&&cc.slidee||!rb.speed),cc.tweese=0,a!==yb.dest&&(yb.dest=a,ob("change"),ec||M()),Z(),V(),W(),O()}function M(){if(sb.initialized){if(!ec)return ec=t(M),void(cc.released&&ob("moveStart"));ac.immediate?yb.cur=ac.to:ac.tweesing?(ac.tweeseDelta=ac.to-yb.cur,D(ac.tweeseDelta)<.1?yb.cur=ac.to:yb.cur+=ac.tweeseDelta*(cc.released?rb.swingSpeed:rb.syncSpeed)):(ac.time=I(+new Date-ac.start,rb.speed),yb.cur=ac.from+ac.delta*a.easing[rb.easing](ac.time/rb.speed,ac.time,0,1,rb.speed)),ac.to===yb.cur?(yb.cur=ac.to,cc.tweese=ec=0):ec=t(M),ob("move"),tb||(m?vb[0].style[m]=n+(rb.horizontal?"translateX":"translateY")+"("+-yb.cur+"px)":vb[0].style[rb.horizontal?"left":"top"]=-G(yb.cur)+"px"),!ec&&cc.released&&ob("moveEnd"),N()}}function N(){Ab.length&&(Db.cur=yb.start===yb.end?0:((cc.init&&!cc.slidee?yb.dest:yb.cur)-yb.start)/(yb.end-yb.start)*Db.end,Db.cur=k(G(Db.cur),Db.start,Db.end),_b.hPos!==Db.cur&&(_b.hPos=Db.cur,m?Ab[0].style[m]=n+(rb.horizontal?"translateX":"translateY")+"("+Db.cur+"px)":Ab[0].style[rb.horizontal?"left":"top"]=Db.cur+"px"))}function O(){Fb[0]&&_b.page!==Jb.activePage&&(_b.page=Jb.activePage,Fb.removeClass(rb.activeClass).eq(Jb.activePage).addClass(rb.activeClass),ob("activePage",_b.page))}function P(){bc.speed&&yb.cur!==(bc.speed>0?yb.end:yb.start)||sb.stop(),hc=cc.init?t(P):0,bc.now=+new Date,bc.pos=yb.cur+(bc.now-bc.lastTime)/1e3*bc.speed,L(cc.init?bc.pos:G(bc.pos)),cc.init||yb.cur!==yb.dest||ob("moveEnd"),bc.lastTime=bc.now}function Q(a,b,d){if("boolean"===e(b)&&(d=b,b=c),b===c)L(yb[a],d);else{if(Qb&&"center"!==a)return;var f=sb.getPos(b);f&&L(f[a],d,!Qb)}}function R(a){return null!=a?i(a)?a>=0&&a<Ib.length?a:-1:Hb.index(a):-1}function S(a){return R(i(a)&&0>a?a+Ib.length:a)}function T(a,b){var c=R(a);return!Rb||0>c?!1:((_b.active!==c||b)&&(Hb.eq(Jb.activeItem).removeClass(rb.activeClass),Hb.eq(c).addClass(rb.activeClass),_b.active=Jb.activeItem=c,W(),ob("active",c)),c)}function U(a){a=k(i(a)?a:yb.dest,yb.start,yb.end);var b={},c=Pb?0:wb/2;if(!tb)for(var d=0,e=Gb.length;e>d;d++){if(a>=yb.end||d===Gb.length-1){b.activePage=Gb.length-1;break}if(a<=Gb[d]+c){b.activePage=d;break}}if(Rb){for(var f=!1,g=!1,h=!1,j=0,l=Ib.length;l>j;j++)if(f===!1&&a<=Ib[j].start+Ib[j].half&&(f=j),h===!1&&a<=Ib[j].center+Ib[j].half&&(h=j),j===l-1||a<=Ib[j].end+Ib[j].half){g=j;break}b.firstItem=i(f)?f:0,b.centerItem=i(h)?h:b.firstItem,b.lastItem=i(g)?g:b.centerItem}return b}function V(b){a.extend(Jb,U(b))}function W(){var a=yb.dest<=yb.start,b=yb.dest>=yb.end,c=(a?1:0)|(b?2:0);if(_b.slideePosState!==c&&(_b.slideePosState=c,Yb.is("button,input")&&Yb.prop("disabled",a),Zb.is("button,input")&&Zb.prop("disabled",b),Yb.add(Vb)[a?"addClass":"removeClass"](rb.disabledClass),Zb.add(Ub)[b?"addClass":"removeClass"](rb.disabledClass)),_b.fwdbwdState!==c&&cc.released&&(_b.fwdbwdState=c,Vb.is("button,input")&&Vb.prop("disabled",a),Ub.is("button,input")&&Ub.prop("disabled",b)),Rb&&null!=Jb.activeItem){var d=0===Jb.activeItem,e=Jb.activeItem>=Ib.length-1,f=(d?1:0)|(e?2:0);_b.itemsButtonState!==f&&(_b.itemsButtonState=f,Wb.is("button,input")&&Wb.prop("disabled",d),Xb.is("button,input")&&Xb.prop("disabled",e),Wb[d?"addClass":"removeClass"](rb.disabledClass),Xb[e?"addClass":"removeClass"](rb.disabledClass))}}function X(a,b,c){if(a=S(a),b=S(b),a>-1&&b>-1&&a!==b&&(!c||b!==a-1)&&(c||b!==a+1)){Hb.eq(a)[c?"insertAfter":"insertBefore"](Ib[b].el);var d=b>a?a:c?b:b-1,e=a>b?a:c?b+1:b,f=a>b;null!=Jb.activeItem&&(a===Jb.activeItem?_b.active=Jb.activeItem=c?f?b+1:b:f?b:b-1:Jb.activeItem>d&&Jb.activeItem<e&&(_b.active=Jb.activeItem+=f?1:-1)),K()}}function Y(a,b){for(var c=0,d=$b[a].length;d>c;c++)if($b[a][c]===b)return c;return-1}function Z(){cc.released&&!sb.isPaused&&sb.resume()}function $(a){return G(k(a,Db.start,Db.end)/Db.end*(yb.end-yb.start))+yb.start}function _(){cc.history[0]=cc.history[1],cc.history[1]=cc.history[2],cc.history[2]=cc.history[3],cc.history[3]=cc.delta}function ab(a){cc.released=0,cc.source=a,cc.slidee="slidee"===a}function bb(b){var c="touchstart"===b.type,d=b.data.source,e="slidee"===d;cc.init||!c&&eb(b.target)||("handle"!==d||rb.dragHandle&&Db.start!==Db.end)&&(!e||(c?rb.touchDragging:rb.mouseDragging&&b.which<2))&&(c||f(b),ab(d),cc.init=0,cc.$source=a(b.target),cc.touch=c,cc.pointer=c?b.originalEvent.touches[0]:b,cc.initX=cc.pointer.pageX,cc.initY=cc.pointer.pageY,cc.initPos=e?yb.cur:Db.cur,cc.start=+new Date,cc.time=0,cc.path=0,cc.delta=0,cc.locked=0,cc.history=[0,0,0,0],cc.pathToLock=e?c?30:10:0,u.on(c?x:w,cb),sb.pause(1),(e?vb:Ab).addClass(rb.draggedClass),ob("moveStart"),e&&(fc=setInterval(_,10)))}function cb(a){if(cc.released="mouseup"===a.type||"touchend"===a.type,cc.pointer=cc.touch?a.originalEvent[cc.released?"changedTouches":"touches"][0]:a,cc.pathX=cc.pointer.pageX-cc.initX,cc.pathY=cc.pointer.pageY-cc.initY,cc.path=E(F(cc.pathX,2)+F(cc.pathY,2)),cc.delta=rb.horizontal?cc.pathX:cc.pathY,cc.released||!(cc.path<1)){if(!cc.init){if(cc.path<rb.dragThreshold)return cc.released?db():c;if(!(rb.horizontal?D(cc.pathX)>D(cc.pathY):D(cc.pathX)<D(cc.pathY)))return db();cc.init=1}f(a),!cc.locked&&cc.path>cc.pathToLock&&cc.slidee&&(cc.locked=1,cc.$source.on(z,g)),cc.released&&(db(),rb.releaseSwing&&cc.slidee&&(cc.swing=(cc.delta-cc.history[0])/40*300,cc.delta+=cc.swing,cc.tweese=D(cc.swing)>10)),L(cc.slidee?G(cc.initPos-cc.delta):$(cc.initPos+cc.delta))}}function db(){clearInterval(fc),cc.released=!0,u.off(cc.touch?x:w,cb),(cc.slidee?vb:Ab).removeClass(rb.draggedClass),setTimeout(function(){cc.$source.off(z,g)}),yb.cur===yb.dest&&cc.init&&ob("moveEnd"),sb.resume(1),cc.init=0}function eb(b){return~a.inArray(b.nodeName,B)||a(b).is(rb.interactive)}function fb(){sb.stop(),u.off("mouseup",fb)}function gb(a){switch(f(a),this){case Ub[0]:case Vb[0]:sb.moveBy(Ub.is(this)?rb.moveBy:-rb.moveBy),u.on("mouseup",fb);break;case Wb[0]:sb.prev();break;case Xb[0]:sb.next();break;case Yb[0]:sb.prevPage();break;case Zb[0]:sb.nextPage()}}function hb(a){return dc.curDelta=(rb.horizontal?a.deltaY||a.deltaX:a.deltaY)||-a.wheelDelta,dc.curDelta/=1===a.deltaMode?3:100,Rb?(o=+new Date,dc.last<o-dc.resetTime&&(dc.delta=0),dc.last=o,dc.delta+=dc.curDelta,D(dc.delta)<1?dc.finalDelta=0:(dc.finalDelta=G(dc.delta/1),dc.delta%=1),dc.finalDelta):dc.curDelta}function ib(a){a.originalEvent[r]=sb;var b=+new Date;if(J+rb.scrollHijack>b&&Sb[0]!==document&&Sb[0]!==window)return void(J=b);if(rb.scrollBy&&yb.start!==yb.end){var c=hb(a.originalEvent);(rb.scrollTrap||c>0&&yb.dest<yb.end||0>c&&yb.dest>yb.start)&&f(a,1),sb.slideBy(rb.scrollBy*c)}}function jb(a){rb.clickBar&&a.target===zb[0]&&(f(a),L($((rb.horizontal?a.pageX-zb.offset().left:a.pageY-zb.offset().top)-Cb/2)))}function kb(a){if(rb.keyboardNavBy)switch(a.which){case rb.horizontal?37:38:f(a),sb["pages"===rb.keyboardNavBy?"prevPage":"prev"]();break;case rb.horizontal?39:40:f(a),sb["pages"===rb.keyboardNavBy?"nextPage":"next"]()}}function lb(a){return eb(this)?void(a.originalEvent[r+"ignore"]=!0):void(this.parentNode!==vb[0]||a.originalEvent[r+"ignore"]||sb.activate(this))}function mb(){this.parentNode===Eb[0]&&sb.activatePage(Fb.index(this))}function nb(a){rb.pauseOnHover&&sb["mouseenter"===a.type?"pause":"resume"](2)}function ob(a,b){if($b[a]){for(qb=$b[a].length,C.length=0,pb=0;qb>pb;pb++)C.push($b[a][pb]);for(pb=0;qb>pb;pb++)C[pb].call(sb,a,b)}}if(!(this instanceof d))return new d(b,p,q);var pb,qb,rb=a.extend({},d.defaults,p),sb=this,tb=i(b),ub=a(b),vb=rb.slidee?a(rb.slidee).eq(0):ub.children().eq(0),wb=0,xb=0,yb={start:0,center:0,end:0,cur:0,dest:0},zb=a(rb.scrollBar).eq(0),Ab=zb.children().eq(0),Bb=0,Cb=0,Db={start:0,end:0,cur:0},Eb=a(rb.pagesBar),Fb=0,Gb=[],Hb=0,Ib=[],Jb={firstItem:0,lastItem:0,centerItem:0,activeItem:null,activePage:0},Kb=new l(ub[0]),Lb=new l(vb[0]),Mb=new l(zb[0]),Nb=new l(Ab[0]),Ob="basic"===rb.itemNav,Pb="forceCentered"===rb.itemNav,Qb="centered"===rb.itemNav||Pb,Rb=!tb&&(Ob||Qb||Pb),Sb=rb.scrollSource?a(rb.scrollSource):ub,Tb=rb.dragSource?a(rb.dragSource):ub,Ub=a(rb.forward),Vb=a(rb.backward),Wb=a(rb.prev),Xb=a(rb.next),Yb=a(rb.prevPage),Zb=a(rb.nextPage),$b={},_b={},ac={},bc={},cc={released:1},dc={last:0,delta:0,resetTime:200},ec=0,fc=0,gc=0,hc=0;tb||(b=ub[0]),sb.initialized=0,sb.frame=b,sb.slidee=vb[0],sb.pos=yb,sb.rel=Jb,sb.items=Ib,sb.pages=Gb,sb.isPaused=0,sb.options=rb,sb.dragging=cc,sb.reload=function(){K()},sb.getPos=function(a){if(Rb){var b=R(a);return-1!==b?Ib[b]:!1}var c=vb.find(a).eq(0);if(c[0]){var d=rb.horizontal?c.offset().left-vb.offset().left:c.offset().top-vb.offset().top,e=c[rb.horizontal?"outerWidth":"outerHeight"]();return{start:d,center:d-wb/2+e/2,end:d-wb+e,size:e}}return!1},sb.moveBy=function(a){bc.speed=a,!cc.init&&bc.speed&&yb.cur!==(bc.speed>0?yb.end:yb.start)&&(bc.lastTime=+new Date,bc.startPos=yb.cur,ab("button"),cc.init=1,ob("moveStart"),s(hc),P())},sb.stop=function(){"button"===cc.source&&(cc.init=0,cc.released=1)},sb.prev=function(){sb.activate(null==Jb.activeItem?0:Jb.activeItem-1)},sb.next=function(){sb.activate(null==Jb.activeItem?0:Jb.activeItem+1)},sb.prevPage=function(){sb.activatePage(Jb.activePage-1)},sb.nextPage=function(){sb.activatePage(Jb.activePage+1)},sb.slideBy=function(a,b){a&&(Rb?sb[Qb?"toCenter":"toStart"](k((Qb?Jb.centerItem:Jb.firstItem)+rb.scrollBy*a,0,Ib.length)):L(yb.dest+a,b))},sb.slideTo=function(a,b){L(a,b)},sb.toStart=function(a,b){Q("start",a,b)},sb.toEnd=function(a,b){Q("end",a,b)},sb.toCenter=function(a,b){Q("center",a,b)},sb.getIndex=R,sb.activate=function(a,b){var c=T(a);rb.smart&&c!==!1&&(Qb?sb.toCenter(c,b):c>=Jb.lastItem?sb.toStart(c,b):c<=Jb.firstItem?sb.toEnd(c,b):Z())},sb.activatePage=function(a,b){i(a)&&L(Gb[k(a,0,Gb.length-1)],b)},sb.resume=function(a){rb.cycleBy&&rb.cycleInterval&&("items"!==rb.cycleBy||Ib[0]&&null!=Jb.activeItem)&&!(a<sb.isPaused)&&(sb.isPaused=0,gc?gc=clearTimeout(gc):ob("resume"),gc=setTimeout(function(){switch(ob("cycle"),rb.cycleBy){case"items":sb.activate(Jb.activeItem>=Ib.length-1?0:Jb.activeItem+1);break;case"pages":sb.activatePage(Jb.activePage>=Gb.length-1?0:Jb.activePage+1)}},rb.cycleInterval))},sb.pause=function(a){a<sb.isPaused||(sb.isPaused=a||100,gc&&(gc=clearTimeout(gc),ob("pause")))},sb.toggle=function(){sb[gc?"pause":"resume"]()},sb.set=function(b,c){a.isPlainObject(b)?a.extend(rb,b):rb.hasOwnProperty(b)&&(rb[b]=c)},sb.add=function(b,c){var d=a(b);Rb?(null==c||!Ib[0]||c>=Ib.length?d.appendTo(vb):Ib.length&&d.insertBefore(Ib[c].el),null!=Jb.activeItem&&c<=Jb.activeItem&&(_b.active=Jb.activeItem+=d.length)):vb.append(d),K()},sb.remove=function(b){if(Rb){var c=S(b);if(c>-1){Hb.eq(c).remove();var d=c===Jb.activeItem;null!=Jb.activeItem&&c<Jb.activeItem&&(_b.active=--Jb.activeItem),K(),d&&(_b.active=null,sb.activate(Jb.activeItem))}}else a(b).remove(),K()},sb.moveAfter=function(a,b){X(a,b,1)},sb.moveBefore=function(a,b){X(a,b)},sb.on=function(a,b){if("object"===e(a))for(var c in a)a.hasOwnProperty(c)&&sb.on(c,a[c]);else if("function"===e(b))for(var d=a.split(" "),f=0,g=d.length;g>f;f++)$b[d[f]]=$b[d[f]]||[],-1===Y(d[f],b)&&$b[d[f]].push(b);else if("array"===e(b))for(var h=0,i=b.length;i>h;h++)sb.on(a,b[h])},sb.one=function(a,b){function c(){b.apply(sb,arguments),sb.off(a,c)}sb.on(a,c)},sb.off=function(a,b){if(b instanceof Array)for(var c=0,d=b.length;d>c;c++)sb.off(a,b[c]);else for(var e=a.split(" "),f=0,g=e.length;g>f;f++)if($b[e[f]]=$b[e[f]]||[],null==b)$b[e[f]].length=0;else{var h=Y(e[f],b);-1!==h&&$b[e[f]].splice(h,1)}},sb.destroy=function(){return d.removeInstance(b),Sb.add(Ab).add(zb).add(Eb).add(Ub).add(Vb).add(Wb).add(Xb).add(Yb).add(Zb).off("."+r),u.off("keydown",kb),Wb.add(Xb).add(Yb).add(Zb).removeClass(rb.disabledClass),Hb&&null!=Jb.activeItem&&Hb.eq(Jb.activeItem).removeClass(rb.activeClass),Eb.empty(),tb||(ub.off("."+r),Kb.restore(),Lb.restore(),Mb.restore(),Nb.restore(),a.removeData(b,r)),Ib.length=Gb.length=0,_b={},sb.initialized=0,sb},sb.init=function(){if(!sb.initialized){if(d.getInstance(b))throw new Error("There is already a Sly instance on this element");d.storeInstance(b,sb),sb.on(q);var a=["overflow","position"],c=["position","webkitTransform","msTransform","transform","left","top","width","height"];Kb.save.apply(Kb,a),Mb.save.apply(Mb,a),Lb.save.apply(Lb,c),Nb.save.apply(Nb,c);var e=Ab;return tb||(e=e.add(vb),ub.css("overflow","hidden"),m||"static"!==ub.css("position")||ub.css("position","relative")),m?n&&e.css(m,n):("static"===zb.css("position")&&zb.css("position","relative"),e.css({position:"absolute"})),rb.forward&&Ub.on(A,gb),rb.backward&&Vb.on(A,gb),rb.prev&&Wb.on(z,gb),rb.next&&Xb.on(z,gb),rb.prevPage&&Yb.on(z,gb),rb.nextPage&&Zb.on(z,gb),Sb.on(y,ib),zb[0]&&zb.on(z,jb),Rb&&rb.activateOn&&ub.on(rb.activateOn+"."+r,"*",lb),Eb[0]&&rb.activatePageOn&&Eb.on(rb.activatePageOn+"."+r,"*",mb),Tb.on(v,{source:"slidee"},bb),Ab&&Ab.on(v,{source:"handle"},bb),u.on("keydown",kb),tb||(ub.on("mouseenter."+r+" mouseleave."+r,nb),ub.on("scroll."+r,h)),sb.initialized=1,K(!0),rb.cycleBy&&!tb&&sb[rb.startPaused?"pause":"resume"](),sb}}}function e(a){return null==a?String(a):"object"==typeof a||"function"==typeof a?Object.prototype.toString.call(a).match(/\s([a-z]+)/i)[1].toLowerCase()||"object":typeof a}function f(a,b){a.preventDefault(),b&&a.stopPropagation()}function g(b){f(b,1),a(this).off(b.type,g)}function h(){this.scrollLeft=0,this.scrollTop=0}function i(a){return!isNaN(parseFloat(a))&&isFinite(a)}function j(a,b){return 0|G(String(a.css(b)).replace(/[^\-0-9.]/g,""))}function k(a,b,c){return b>a?b:a>c?c:a}function l(a){var b={};return b.style={},b.save=function(){if(a&&a.nodeType){for(var c=0;c<arguments.length;c++)b.style[arguments[c]]=a.style[arguments[c]];return b}},b.restore=function(){if(a&&a.nodeType){for(var c in b.style)b.style.hasOwnProperty(c)&&(a.style[c]=b.style[c]);return b}},b}var m,n,o,p="sly",q="Sly",r=p,s=b.cancelAnimationFrame||b.cancelRequestAnimationFrame,t=b.requestAnimationFrame,u=a(document),v="touchstart."+r+" mousedown."+r,w="mousemove."+r+" mouseup."+r,x="touchmove."+r+" touchend."+r,y=(document.implementation.hasFeature("Event.wheel","3.0")?"wheel.":"mousewheel.")+r,z="click."+r,A="mousedown."+r,B=["INPUT","SELECT","BUTTON","TEXTAREA"],C=[],D=Math.abs,E=Math.sqrt,F=Math.pow,G=Math.round,H=Math.max,I=Math.min,J=0;u.on(y,function(a){var b=a.originalEvent[r],c=+new Date;(!b||b.options.scrollHijack<c-J)&&(J=c)}),d.getInstance=function(b){return a.data(b,r)},d.storeInstance=function(b,c){return a.data(b,r,c)},d.removeInstance=function(b){return a.removeData(b,r)},function(a){function b(a){var b=(new Date).getTime(),d=Math.max(0,16-(b-c)),e=setTimeout(a,d);return c=b,e}t=a.requestAnimationFrame||a.webkitRequestAnimationFrame||b;var c=(new Date).getTime(),d=a.cancelAnimationFrame||a.webkitCancelAnimationFrame||a.clearTimeout;s=function(b){d.call(a,b)}}(window),function(){function a(a){for(var d=0,e=b.length;e>d;d++){var f=b[d]?b[d]+a.charAt(0).toUpperCase()+a.slice(1):a;if(null!=c.style[f])return f}}var b=["","Webkit","Moz","ms","O"],c=document.createElement("div");m=a("transform"),n=a("perspective")?"translateZ(0) ":""}(),b[q]=d,a.fn[p]=function(b,c){var f,g;return a.isPlainObject(b)||(("string"===e(b)||b===!1)&&(f=b===!1?"destroy":b,g=Array.prototype.slice.call(arguments,1)),b={}),this.each(function(a,e){var h=d.getInstance(e);h||f?h&&f&&h[f]&&h[f].apply(h,g):h=new d(e,b,c).init()})},d.defaults={slidee:null,horizontal:!1,itemNav:null,itemSelector:null,smart:!1,activateOn:null,activateMiddle:!1,scrollSource:null,scrollBy:0,scrollHijack:300,scrollTrap:!1,dragSource:null,mouseDragging:!1,touchDragging:!1,releaseSwing:!1,swingSpeed:.2,elasticBounds:!1,dragThreshold:3,interactive:null,scrollBar:null,dragHandle:!1,dynamicHandle:!1,minHandleSize:50,clickBar:!1,syncSpeed:.5,pagesBar:null,activatePageOn:null,pageBuilder:function(a){return"<li>"+(a+1)+"</li>"},forward:null,backward:null,prev:null,next:null,prevPage:null,nextPage:null,cycleBy:null,cycleInterval:5e3,pauseOnHover:!1,startPaused:!1,moveBy:300,speed:0,easing:"swing",startAt:null,keyboardNavBy:null,draggedClass:"dragged",activeClass:"active",disabledClass:"disabled"}}(jQuery,window);